import { useEffect, useState } from "react";
import { MdOutlineCheckCircle, MdRadioButtonUnchecked } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { logout } from "../../app/Api";
import { setIsHomeProcess } from "../../app/GlobalSlice";
import { handleAxiosNetworkError, handleResponse200 } from "../../utils/HttpUtils";
import { notifyError, notifySuccess } from "../../utils/Notification";
import { formatRupiah } from "../../utils/NumericHelper";
import { isPhone } from "../../utils/PlatformHelper";
import { createTransaction, getOfferedPaymentMechanism, getPaymentChannel, getTransactions } from "./Api";
import PaymentInstructionDialog from "./PaymentInstructionDialog";
import PaymentOnSite from "./PaymentOnSite";
import PaymentTransfer from "./PaymentTransfer";
import PaymentVA from "./PaymentVA";
import UnverifiedReceipt from "./UnverifiedReceipt";

import { format } from "date-fns"

const phaseToLabel = (phase) => {
  if (phase === "on_payment") {
    return 'Pembayaran'
  }
  else if (phase === "on_biodata") {
    return 'Pelengkapan Biodata'
  }
  else if (phase === "on_document") {
    return 'Pelengkapan Dokumen'
  }
  else if (phase === "on_finish") {
    return 'Selesai'
  }
}

const PaymentPage = () => {

  const dispatch = useDispatch()
  const navigate = useNavigate()

  const { member, systemProfile, screenSize } = useSelector(state => state.global)

  const [hashImage, setHashImage] = useState(Date.now());

  const [refetchData, setRefetchData] = useState(true)
  const [refetchDataReceipt, setRefetchDataReceipt] = useState(true)

  const [offeredPaymentMechanism, setOfferedPaymentMechanism] = useState([])

  const [transacions, setTransactions] = useState([])

  const [groupedPayChans, setGroupedPayChans] = useState([])

  const [selectedPayChan, setSelectedPayChan] = useState(null)

  const [instructionDialog, setInstructionDialog] = useState({
    isOpen: false,
    selectedData: null
  })

  useEffect(() => {
    document.body.style.backgroundColor = isPhone(screenSize.width) ? 'white' : '#232745';
  }, [screenSize.width])


  useEffect(() => {
    getOfferedPaymentMechanism()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setOfferedPaymentMechanism(payload)
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => {

      })
  }, [])


  useEffect(() => {

    if (!refetchData) return;

    dispatch(setIsHomeProcess(true))
    
    Promise.all([getTransactions(), getPaymentChannel()])
      .then(ress => {
        const res1 = ress[0]
        const res2 = ress[1]

        handleResponse200({
          httpResponse: res1,
          onSuccess: payload => {
            setTransactions(payload)
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
        
        handleResponse200({
          httpResponse: res2,
          onSuccess: payload => {
            setGroupedPayChans(payload)
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })

      })
      .catch(handleAxiosNetworkError)
      .finally(() => { 
        dispatch(setIsHomeProcess(false))
        setRefetchData(false)
      })

  }, [refetchData])

  function onMakePayment(
    selectedPaymentCode,
    selectedPaymentChannel
  ) {
    dispatch(setIsHomeProcess(true))

    const payload = {
      paymentMethod : selectedPaymentCode,
      paymentChannel: selectedPaymentChannel
    }

    createTransaction(payload)
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            setRefetchData(true)
            window.scrollTo(0, 0)
            notifySuccess('Transaksi berhasil dibuat')
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => dispatch(setIsHomeProcess(false)))
  }

  function onLogout() {
    dispatch(setIsHomeProcess(true))

    logout()
      .then(res => {
        handleResponse200({
          httpResponse: res,
          onSuccess: payload => {
            notifySuccess('Logout Berhasil')
            navigate("/login")
          },
          onRecovFailure: errors => errors.forEach(err => {
              notifyError(err)
          }),
          onUnAuth: error => {
              
          },
          onTechnicalError: errors => errors.forEach(err => {
              notifyError(err)
          })
        })
      })
      .catch(handleAxiosNetworkError)
      .finally(() => { dispatch(setIsHomeProcess(false)) })
  }

  if (!systemProfile) return null;

  if (member === null) {
    return (
      <div
        className="w-screen h-screen"
      >

        <div
          className="py-10 flex justify-center"
        >
          
          <div
            className="relative rounded-sm flex"
            style={{
              width: '650px',
              height: '700px'
            }}
          >
            
            <div
              className="flex-1 bg-white p-10"
            />
          </div>
          

        </div>
      </div>
    )
  }

  return (
    <>
    { instructionDialog.isOpen && (
        <PaymentInstructionDialog
          selectedData={instructionDialog.selectedData}
          onClose={() => setInstructionDialog({
            ...instructionDialog,
            selectedData: null,
            isOpen: false
          })}
        />
    )}
    <div
      className="h-screen"
    >
      <div
        className="py-10 flex flex-col items-center justify-center space-y-3"
      >

        <div
          className="relative rounded-sm bg-white"
          style={{
            width: isPhone(screenSize.width) ? '100%' : '650px'
          }}
        >
          <div
            className=""
          >
            <div
              className="py-5 pt-8 text-center uppercase font-bold" 
              style={{
                fontFamily: 'Nunito',
                fontSize: '20px'
              }}
            >
              <label>Tahap Pembayaran</label>
            </div>
            <div
              className="flex justify-center py-5"
            >
              <img src={systemProfile.companyLogo + '?' + hashImage} width={'150px'}/>
            </div>
            <div
              className="py-5 border-t border-b"
            >
              <div 
                className="text-center font-bold"
                style={{
                  fontFamily: 'Nunito',
                  fontSize: '18px'
                }}
              >
                Detail Program
              </div>
              <div className="flex justify-center">
                <div
                  className={
                    "w-1/2 space-y-2 py-3 " +
                    (isPhone(screenSize.width) ? ' px-5 ' : '')
                  }
                  style={{
                    fontSize: '14px'
                  }}
                >
                  <div
                    className={
                      "flex "+
                      (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' space-x-2 ')
                    }
                  >
                    <div className="w-[80px]">Program</div>
                    {!isPhone(screenSize.width) && (<div>:</div>)}
                    <div className="font-bold w-[200px]">{member.program.label}</div>
                  </div>
                  <div
                    className={
                      "flex "+
                      (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' space-x-2 ')
                    }
                  >
                    <div className="w-[80px]">Sekolah</div>
                    {!isPhone(screenSize.width) && (<div>:</div>)}
                    <div className="font-bold w-[200px]">{member.sekolah.label}</div>
                  </div>
                  <div
                    className={
                      "flex "+
                      (isPhone(screenSize.width) ? ' flex-col text-left py-1 ' : ' space-x-2 ')
                    }
                  >
                    <div className="w-[80px]">Pendaftaran</div>
                    {!isPhone(screenSize.width) && (<div>:</div>)}
                    <div className="font-bold w-[200px]">{formatRupiah(member.biayaPendaftaran)}</div>
                  </div>
                </div>
              </div>
            </div>
            {transacions.length > 0 && (
              <div
                className="py-5 border-t border-b"
              >
                <div 
                  className="text-center font-bold"
                  style={{
                    fontFamily: 'Nunito',
                    fontSize: '18px'
                  }}
                >
                  Catatan Transaksi Otomatis
                </div>
                <div
                  className="py-3 px-2 bg-gray-100 text-center"
                >
                  Transaksi Otomatis telah dibuat. silahkan lakukan pembayaran sebelum batas waktu pembayaran.
                </div> 
                <div className="flex justify-center">
                  <div
                    className={
                      "space-y-3 py-3 " +
                      (isPhone(screenSize.width) ? "  " : " w-2/3 ")
                    }
                    style={{
                      fontSize: '14px'
                    }}
                  >
                    {transacions.map(trx => (
                      <div
                        className="p-3 rounded-md border space-y-1"
                      >
                        <div
                          className="flex space-x-2"
                        >
                          <div className="w-24">ID</div>
                          <div>:</div>
                          <div className="font-bold w-[200px]">{trx.idTransaction}</div>
                        </div>
                        <div
                          className="flex space-x-2"
                        >
                          <div className="w-24">Channel</div>
                          <div>:</div>
                          <div className="font-bold w-[200px]">{trx.paymentChannel}</div>
                        </div>
                        <div
                          className="flex space-x-2"
                        >
                          <div className="w-24">Kode Bayar</div>
                          <div>:</div>
                          <div className="font-bold w-[200px]">{trx.paymentCode}</div>
                        </div>
                        <div
                          className="flex space-x-2"
                        >
                          <div className="w-24">Jumlah Bayar</div>
                          <div>:</div>
                          <div className="font-bold w-[200px]">{formatRupiah(trx.totalAmount)}</div>
                        </div>
                        <div
                          className="flex space-x-2"
                        >
                          <div className="w-24">Tgl. dibuat</div>
                          <div>:</div>
                          <div className="font-bold w-[200px]">{format(new Date(trx.createdAt), "dd/MM/yyyy HH:mm")}</div>
                        </div>
                        <div
                          className="flex space-x-2"
                        >
                          <div className="w-24">Batas Bayar</div>
                          <div>:</div>
                          <div className="font-bold w-[200px]">{format(new Date(trx.expiredAt), "dd/MM/yyyy HH:mm")}</div>
                        </div>
                        <div
                          className="flex space-x-2"
                        >
                          <div className="w-24">Status</div>
                          <div>:</div>
                          <div className="font-bold w-[200px]">{trx.paymentStatus}</div>
                        </div>
                        <div
                          className="pt-3"
                        >
                          <button
                            className="p-1.5 px-5 bg-blue-500 text-white rounded-md"
                            style={{
                              fontSize: '14px'
                            }}
                            onClick={() => setInstructionDialog({
                              ...instructionDialog,
                              isOpen: true,
                              selectedData: trx
                            })}
                          >
                            Panduan Pembayaran 
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            )}
            <UnverifiedReceipt 
              isRefetchData={refetchDataReceipt}
              onFinishRefetchData={() => setRefetchDataReceipt(false)}
            />
            <div
              className="py-5 border-t border-b px-8 bg-gray-100 space-y-2"
            >
              <div
                className="font-bold text-center uppercase"
                style={{
                  fontFamily: 'Nunito',
                  fontSize: '18px'
                }}
              >
                Informasi
              </div>
              <div
                className="text-center"
                style={{
                  fontSize: '14px'
                }}
              >
                <ol className="text-left space-y-1">
                  <li className="p-0">
                    Silahkan pilih salah satu metode pembayaran di bawah.     
                  </li>
                  <li className="p-0">
                    Anda masih dapat mengganti metode pembayaran jika anda ingin mengganti proses pembayaran dengan metode pembayaran yang lainnya
                  </li>
                </ol>
              </div>
            </div>
          </div>
          <div
            className="p-2 space-y-3 pb-5"
          >
            {offeredPaymentMechanism.find(op => op === "payment_gateway") && (
              <PaymentVA 
                groupedPayChans={groupedPayChans}
                onMakePayment={onMakePayment}
              />
            )}
            {offeredPaymentMechanism.find(op => op === "manual_transfer") && (
              <PaymentTransfer 
                onSuccessUploadPaymentReceipt={() => {
                  window.scrollTo(0, 0)
                  setRefetchDataReceipt(true)
                }}
              />
            )}
            {offeredPaymentMechanism.find(op => op === "on_site_payment") && (
              <PaymentOnSite />
            )}
          </div>
          <div
            className="py-5 flex justify-center border-t"
          >
            <div
              className="w-2/3 px-10 space-y-5"
            >
              <button
                className="w-full border border-blue-500 py-1.5 rounded-md hover:bg-blue-500 hover:text-white"
                style={{
                  fontSize: '14px'
                }}
                onClick={onLogout}
              >
                Keluar
              </button>
            </div>
          </div>
        </div>


      </div>

    </div>
    </>
  )

}

export default PaymentPage;